export enum AccordionListNames {
  doctorList = 'doctorList',
  sharedWith = 'sharedDoctorList',
}

export const MAX_ROWS_COUNT = 3;

export const MOCKED_ACCESS_CODE = 'slkdjaklsfdjdf7dfdf';
